import type { PlanAmount } from '../../../../../display-values/lumpsumPlanAmount'

/** Badge for the user's existing monthly SIP (not the recommendation). */
export function SipAmountBadge({ currentSipAmount }: { currentSipAmount: PlanAmount }) {
  if (currentSipAmount.value <= 0) {
    return null
  }

  return (
    <div className="rounded-[6px] bg-[#F0F4F7] px-1.5 py-0.5 text-[12px] font-[500] text-[#3D3D3D]">
      SIP {currentSipAmount.label}
    </div>
  )
}

/** Top-right target SIP on action cards (start / increase to / reduce to). */
export function SipFundCardTopRightLabel({
  label,
  targetSipAmount
}: {
  label: string
  targetSipAmount: PlanAmount
}) {
  if (targetSipAmount.value <= 0) {
    return null
  }

  return (
    <div className="text-right shrink-0 -mt-[2px]">
      <div className="text-[13px] font-[400] text-[#6A6E6E]">{label}</div>
      <div className="pt-0.5 text-[13px] font-[500] text-[#232323]">
        {targetSipAmount.label}/mo
      </div>
    </div>
  )
}

export function SipFundCardActionLabel({ label }: { label: string }) {
  return <div className="text-right shrink-0 -mt-[2px] text-[13px] font-[500] text-[#232323]">{label}</div>
}
